import { render, staticRenderFns } from "./CarritoOrdenes.vue?vue&type=template&id=2d6db83d"
import script from "./CarritoOrdenes.vue?vue&type=script&lang=ts"
export * from "./CarritoOrdenes.vue?vue&type=script&lang=ts"
import style0 from "./CarritoOrdenes.vue?vue&type=style&index=0&id=2d6db83d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports